<template>
    <div class="taskAdd">
        <Head-view :showStyle="7"></Head-view>
        <div class="main">
            <div class="breadcrumb" @click="backClose">
                故障管理 &nbsp;/&nbsp;
                <span style="color: rgba(132, 133, 135, 1)">{{
                    editTitle
                }}</span>
            </div>
            <div class="breadcrumbChilder">{{ editTitle }}</div>
            <div class="showTba">
                <div class="addBox">
                    <div class="addBoxTop">
                        <div class="addBoxLeft">
                            <div class="instMsg fontSize">基础信息</div>
                            <div class="commRowstyle instMsg">
                                <div class="inpTitle">上报时间:</div>
                                <div class="inpFrom">
                                    {{ faultMsgObj.reportTime }}
                                </div>
                            </div>
                            <div class="commRowstyle marginTop_20 instMsg">
                                <div class="inpTitle">巡检员:</div>
                                <div class="inpFrom">
                                    {{ faultMsgObj.staffName
                                    }}<span v-if="faultMsgObj.staffDept">({{ faultMsgObj.staffDept }})</span>
                                </div>
                            </div>
                            <div class="commRowstyle marginTop_20 instMsg">
                                <div class="inpTitle">点位名称:</div>
                                <div class="inpFrom">
                                    {{ faultMsgObj.placeName }}
                                </div>
                            </div>
                            <div
                                class="
                                    commRowstyle
                                    marginTop_20
                                    instMsg
                                    stopImg
                                "
                            >
                                <div class="inpTitle">点位图片:</div>
                                <div class="inpFrom stopImgInpFrom">
                                    <img
                                        v-if="faultMsgObj.placePicture"
                                        :src="faultMsgObj.placePicture"
                                        alt=""
                                    />
                                    <img
                                        v-if="!faultMsgObj.placePicture"
                                        src="../../../assets/placeDefaultImg.png"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="addBoxRight">
                            <div class="addBoxRightStart">
                                <img
                                    v-if="faultMsgObj.status == 3"
                                    src="../../../assets/fault/okProcessed.png"
                                    alt=""
                                />
                                <img
                                    v-if="faultMsgObj.status == 1"
                                    src="../../../assets/fault/Processeding.png"
                                    alt=""
                                />
                                <img
                                    v-if="faultMsgObj.status == 2"
                                    src="../../../assets/fault/loadingProcessed.png"
                                    alt=""
                                />
                            </div>
                        </div>
                    </div>

                    <div class="addBoxBottom">
                        <div
                            class="
                                commRowstyle
                                marginTop_20
                                instMsg
                                stopImg
                                upImgMsg
                            "
                        >
                            <div class="inpTitle">上报详情:</div>
                            <div class="inpFrom">
                                <div class="imgFromBox">
                                    <div
                                        class="inpImgBox"
                                        v-for="(
                                            item, key
                                        ) in faultMsgObj.faultPicList"
                                        :key="key"
                                        :class="[
                                            key == 0 ? '' : 'imgMarginLeft_34',
                                        ]"
                                    >
                                        <img :src="item" alt="" />
                                    </div>
                                </div>
                                <div class="inpFontDisp">
                                    描述： {{ faultMsgObj.details }}
                                </div>
                            </div>
                        </div>
                        <div class="commRowstyle marginTop_23 instMsg" >
                            <div class="inpTitle">相关任务:</div>
                            <div class="addBoxInpBottom">
                                <div class="fontLeft" v-if="faultMsgObj.taskName != null">
                                    {{ faultMsgObj.taskName }}
                                </div>
                                <div class="fontLeft fontLeftColor" v-if="faultMsgObj.taskName == null">
                                    无
                                </div>
                                <div class="fontRightBtn" @click="seeTask()" v-if="faultMsgObj.taskName != null">查看任务</div>
                            </div>
                        </div>
                        <div class="commRowstyle marginTop_23 instMsg" >
                            <div class="inpTitle">相关路线:</div>
                            <div class="addBoxInpBottom">
                                <div class="fontLeft" v-if="faultMsgObj.routeName != null">
                                    {{ faultMsgObj.routeName }}
                                </div>
                                <div class="fontLeft fontLeftColor" v-if="faultMsgObj.routeName == null">
                                    无
                                </div>
                                <div class="fontRightBtn" @click="seeRouter()" v-if="faultMsgObj.routeName != null">查看路线</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="routerMsgBox">
                    <div class="routerName">处理详情</div>
                    <div class="routerMenu">
                        <div class="menuSelect" v-for="(item, key) in faultMsgObj.handleList" :key="key">
                            <div class="menuNumLeft">
                                <div class="menuNum">
                                    <div class="frame">
                                        <div class="numIco"></div>
                                    </div>
                                </div>
                                <div class="dashed" v-if="key != faultMsgObj.handleList.length - 1"></div>
                            </div>
                            <div class="menuNumMsgRight">
                                <div class="menuMsgImg_1">
                                    <div class="time">{{ item.handleTime }}</div>
                                    <div class="hlandPeople">
                                        <span>处理人:</span
                                        >{{ item.staffname }}
                                        <a v-if="item.staffdept">
                                            ({{ item.staffdept }})
                                        </a>
                                    </div>
                                </div>
                                <div class="menuMsgImg_2">{{ item.remarks }}</div>
                                <div class="menuMsgImg_3">
                                    <div class="faultImg" v-for="(imgUrl, k) in  item.handlePicList" :key="k">
                                        <img :src="imgUrl" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeadView from "@/components/HeadView";
export default {
    name: "taskAdd",
    data() {
        return {
            insId: "",
            editTitle: "故障处理详情",
            inspectionObj: {
                status: 4,
            },

            faultMsgObj: {},
        };
    },

    components: {
        HeadView,
    },

    mounted() {
        this.insId = Number(localStorage.getItem("insId"));
        this.faultId = this.$route.query.id;
        this.faultMsgInfo();
    },

    methods: {
        faultMsgInfo() {
            let data = {
                token: this.getCookie(),
                faultId: this.faultId,
            };

            this.request
                .post(this.baseUrl + "fault/getFaultDetail", data)
                .then((res) => {
                    if (res.code == 0) {
                        this.faultMsgObj = res.data;
                    } else {
                        this.$message({
                            type: "warning",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$messaeg({
                        type: "error",
                        message: "出错了，获取故障详情失败",
                    });
                });
        },

        seeRouter() {
            this.$router.push({
                path: "/routers/routersAdd",
                query: {
                    id: this.faultMsgObj.routeId,
                },
            });
        },

        seeTask() {
            this.$router.push({
                path: "/task/taskAdd",
                query: {
                    id: this.faultMsgObj.taskId,
                },
            });
        },

        backClose() {
            this.$router.replace("/fault");
        },
    },
};
</script>

<style lang="less" scoped>
.taskAdd {
    position: relative;
    height: 100vh;
    .main {
        margin-right: 24px;
        padding: 72px 0 0 227px;
        overflow: hidden;
        .breadcrumb {
            color: rgba(84, 85, 86, 1);
            font-size: 12px;
            line-height: 20px;
            font-weight: 400;
            cursor: pointer;
        }
        .breadcrumbChilder {
            margin-top: 24px;
            height: 20px;
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            line-height: 20px;
            font-weight: 400;
        }

        .showTba {
            display: flex;
            flex-direction: row;
            margin-top: 24px;
            margin-right: 7px;
            height: 692px;
            background: #fff;
        }
    }

    .addBox {
        padding: 24px 0 0 24px;
        width: 730px;

        .addBoxTop {
            display: flex;
            flex-direction: row;
        }

        .addBoxBottom {
            width: 100%;

            .addBoxInpBottom {
                width: 480px;
                color: rgba(0, 0, 0, 1);

                .fontLeft {
                    float: left;
                }

                .fontLeftColor {
                    color: rgba(128, 128, 128, .7);
                }

                .fontRightBtn {
                    float: right;
                    width: 88px;
                    height: 31px;
                    background: rgba(4, 134, 254, 1);
                    border-radius: 4px;
                    color: #fff;
                    font-size: 14px;
                    text-align: center;
                    line-height: 31px;
                    cursor: pointer;
                }
            }

            .inpBtn {
            }
        }

        .addBoxLeft {
            width: 422px;
        }

        .addBoxRight {
            height: 200px;
            .addBoxRightStart {
                margin-left: 36px;
                margin-top: 19px;
            }
        }

        .instMsg {
            color: rgba(84, 85, 86, 1);
            font-size: 16px;
            font-weight: 500;
        }

        .fontSize {
            font-size: 18px;
        }

        .userNum {
            line-height: 40px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
        }

        .commRowstyle {
            margin-top: 12px;
            display: flex;
            flex-direction: row;
            .inpTitle {
                width: 138px;
                color: rgba(84, 85, 86, 1);
                font-size: 16px;
                font-weight: 500;
                span {
                    color: red;
                }
            }
            .inpFrom {
                width: 265px;
                color: rgba(0, 0, 0, 1);

                span {
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(166, 166, 166, 1);
                }
            }

            .routerImg {
                width: 388px;
                height: 388px;
                overflow: hidden;
                img {
                    width: 100%;
                }
            }

            .codeFont {
                line-height: 40px;
                font-size: 14px;
            }
        }

        .marginTop_20 {
            margin-top: 20px;
        }

        .marginTop_23 {
            margin-top: 23px;
        }

        .marginLeft_40 {
            margin-left: 40px;
            text-align: left;
        }

        .checkedDate {
            margin-top: 13px;
            line-height: 40px;

            .checkedOne {
                width: 125px;
            }

            .checkedMon {
                width: 231px;
            }

            /deep/ .el-input__inner {
                width: 86px;
            }

            .checkedDay {
                width: 262px;
                /deep/ .el-input__inner {
                    width: 153px;
                }
            }

            .textarea {
                width: 493px;
            }
        }

        .tip {
            padding-top: 21px;
            padding-left: 15px;
            color: rgba(144, 147, 153, 1);
            font-size: 13px;
            height: 19px;
            font-weight: 400;
            text-align: left;
        }

        .userNumber {
            padding-bottom: 10px;
            color: rgba(84, 85, 86, 1);
            font-size: 14px;
            font-weight: 500;
        }

        .tipBox {
            padding-left: 15px;

            > .tip {
                padding: 0;
                padding-top: 1px;
            }
        }

        .stopImg {
            width: 100%;
            height: 78px;

            .stopImgInpFrom {
                width: 78px;
                height: 78px;

                img {
                    width: 100%;
                }
            }

            .imgFromBox {
                width: 480px;
                max-height: 64px;
                overflow-y: auto;
                .inpImgBox {
                    float: left;
                    width: 64px;
                    height: 64px;

                    img {
                        width: 100%;
                    }
                }

                .imgMarginLeft_34 {
                    margin-left: 34px;
                }
            }

            .inpFontDisp {
                font-size: 12px;
                color: rgba(128, 128, 128, 1);
            }
        }

        .upImgMsg {
            width: 100%;
            height: 80px;
            overflow: hidden;
        }
    }

    .routerMsgBox {
        display: flex;
        flex-direction: row;
        margin: 24px 0 0 64px;
        width: 100%;
        background: rgba(255, 255, 255, 1);

        .routerName {
            width: 138px;
            color: rgba(48, 49, 51, 1);
            text-align: left;
            font-size: 16px;
        }

        .routerList {
            margin-top: 20px;
        }

        .routerMenu {
            margin-top: 50px;
            width: 100%;
            height: 100%;
            overflow-y: auto;

            .menuSelect {
                display: flex;
                flex-direction: row;
                height: auto;
                .menuNumLeft {
                    width: 39px;
                    overflow: hidden;
                    .menuNum {
                        float: left;
                        width: 100%;
                        .frame {
                            width: 24px;
                            height: 24px;
                            border-radius: 45px;
                            border: 1px solid rgba(25, 137, 250, 1);

                            .numIco {
                                margin: 4px auto 0;
                                width: 16px;
                                height: 16px;
                                line-height: 24px;
                                border-radius: 45px;
                                background: rgba(25, 137, 250, 1);
                            }
                        }
                    }
                    .dashed {
                        float: left;
                        margin-left: 12px;
                        width: 0px;
                        height: 78%;
                        border: 1px dashed rgba(25, 137, 250, 1);
                    }
                }

                .menuNumMsgRight {
                    width: 471px;
                    height: auto;

                    .menuMsgImg_1 {
                        width: 421px;
                        height: 20px;
                        .time {
                            float: left;
                            width: 130px;
                            font-size: 15px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 1);
                            text-align: left;
                        }

                        .hlandPeople {
                            float: right;
                            width: 50%;
                            font-size: 16px;
                            font-weight: 500;
                            color: rgba(0, 0, 0, 1);
                            text-align: right;
                            span {
                                color: rgba(128, 128, 128, 1);
                            }

                            a {
                                color: rgba(0, 0, 0, 1);
                                text-decoration: none;
                            }
                        }
                    }

                    .menuMsgImg_2 {
                        margin-top: 10px;
                        font-size: 16px;
                        font-weight: 400;
                        color: rgba(25, 137, 250, 1);
                        text-align: left;
                        width: 100%;
                    }

                    .menuMsgImg_3 {
                        margin-top: 10px;

                        .faultImg {
                            margin-right: 5px;
                            margin-bottom: 5px;
                            width: 64px;
                            height: 64px;
                            overflow: hidden;
                            float: left;
                            img {
                                width: 100%;
                            }
                        }

                        .marginImgLeft {
                            margin-left: 15px;
                        }
                    }
                }
            }

            .marginTop_21 {
                margin-top: 21px;
            }
        }
    }
}
</style>